import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const StoresPage = lazy(() => import('../pages/stores/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const FranchisePage = lazy(() => import('../pages/franchise/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/stores',
    element: <StoresPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/franchise',
    element: <FranchisePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
